/**
 * ISO string at UTC midnight for the calendar day of `date` (ignoring its local
 * time component). All-day events are stored/transmitted as UTC-midnight
 * timestamps so the day is timezone-stable; see the all-day handling in
 * `submitEventChange` and the Google/Outlook appliers.
 */
export function toUtcMidnightIso(date: Date): string {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString();
}
